export enum TealiumPage {
	CustomizeDeal = 'payment-terms',
	DealDetails = 'show-deal',
	TradeIn1 = 'trade-1',
	TradeIn2 = 'trade-2',
	TradeInSlider = 'trade-4',
	TradeIn5 = 'trade-5',
	Protections = 'protections-list',
	Rebates = 'rebates',
	SaveDealForm = 'save-deal',
	HowToTestDrive = 'how-test-drive',
	WhenToTestDrive = 'when-test-drive',
	AllSet = 'all-set',
}

export enum TealiumForm {
	CompleteDeal = 'digitalRetailCompletedDealResponsive1',
	TestDrive = 'digitalRetailScheduleTestdriveResponsive1',
}

export enum TealiumLink {
	ScheduleTestDrive = 'scheduleTestDrive',
	TradeIn = 'tradeIn',
	Rebate = 'priceAdjustments',
	DealDetails = 'dealDetails',
}
